export default {
	uid: '',
	asset: {},
	duration: '',
	breakpoints: [],
	credits: '',
	posterUid: '',
	externalLessonUid: '',
}
